var _path, _path2, _ellipse, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1447 14.9468V9C44.1447 7.34314 42.8015 6 41.1447 6H11C9.34315 6 8 7.34315 8 9V63.8382C8 65.4951 9.34315 66.8382 11 66.8382H26.0723",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6055 19.9491H64.5984C66.2553 19.9491 67.5984 21.2922 67.5984 22.9491V81C67.5984 82.6569 66.2553 84 64.5984 84H32.6055C30.9486 84 29.6055 82.6569 29.6055 81V22.9491C29.6055 21.2922 30.9486 19.9491 32.6055 19.9491Z",
    fill: "#6BE3A2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.6017,
    cy: 70.2748,
    rx: 3.59393,
    ry: 3.55838,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6041 44.2746V45.3659C80.6026 47.9237 79.7661 50.4125 78.2193 52.4611C76.6725 54.5097 74.4983 56.0084 72.021 56.7336C69.5437 57.4588 66.8959 57.3717 64.4727 56.4853C62.0494 55.5989 59.9805 53.9607 58.5744 51.8149C57.1684 49.6692 56.5005 47.1309 56.6705 44.5787C56.8405 42.0264 57.8392 39.5969 59.5176 37.6526C61.1961 35.7082 63.4644 34.3531 65.9842 33.7894C68.504 33.2257 71.1404 33.4836 73.5001 34.5247",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6041 44.2746V45.3659C80.6026 47.9237 79.7661 50.4125 78.2193 52.4611C76.6725 54.5097 74.4983 56.0084 72.021 56.7336C69.5437 57.4588 66.8959 57.3717 64.4727 56.4853C62.0494 55.5989 59.9805 53.9607 58.5744 51.8149C57.1684 49.6692 56.5005 47.1309 56.6705 44.5787C56.8405 42.0264 57.8392 39.5969 59.5176 37.6526C61.1961 35.7082 63.4644 34.3531 65.9842 33.7894C68.504 33.2257 71.1404 33.4836 73.5001 34.5247",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6041 44.2746V45.3659C80.6026 47.9237 79.7661 50.4125 78.2193 52.4611C76.6725 54.5097 74.4983 56.0084 72.021 56.7336C69.5437 57.4588 66.8959 57.3717 64.4727 56.4853C62.0494 55.5989 59.9805 53.9607 58.5744 51.8149C57.1684 49.6692 56.5005 47.1309 56.6705 44.5787C56.8405 42.0264 57.8392 39.5969 59.5176 37.6526C61.1961 35.7082 63.4644 34.3531 65.9842 33.7894C68.504 33.2257 71.1404 33.4836 73.5001 34.5247",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.603 35.8768L68.6232 47.75L65.0293 44.1916",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.807f86593aaee2b7e6b7b4e3d1d65c32.svg";
export { ForwardRef as ReactComponent };